import { CircularProgress } from '@mui/material'
import styles from './Options.module.css'
import LocationOn from '@mui/icons-material/LocationOn'
import classNames from 'classnames'


interface OptionsProps{
    options: any[]
    error: any
    isLoading: boolean
    optionsOpen?: boolean
    onOptionClick: (event: any) => void
}

export const Options = (props: OptionsProps) => {
    const {
        options = [],
        error,
        isLoading = false,
        optionsOpen = true,
        onOptionClick
    } = props

    if (optionsOpen === false){
        return (
            null
        )
    }

    if (options === null){
        return (
            null
        )
    }

    if (options?.length === 0){
        return (
            null
        )
    }

    if (isLoading === true){
        return (
            <div className={styles.Options}>
                <div className={styles.Options__ProgressContainer}>
                    <CircularProgress size="5rem" color="success" />
                </div>
            </div>
        )
    }

    const handleOptionlick = (event: any) => {
        onOptionClick?.(event)
    }

    const optionsClasses = classNames(styles.Options, {
        [styles[`Options--Error`]]: error !== null,
    })

    return (
        <div className={optionsClasses}>
            <div className={styles.Options__ListContainer}>
                <ul className={styles.Options__List}>
                    {options.map((option, index) => (
                            <li
                                key={option.googlePlaceId}
                                className={styles.Options__ListItem}
                                onClick={() => handleOptionlick(option)}
                                // onClick={() => handleSuggestionClick(suggestion)}
                                // className={index === selectedIndex ? 'selected' : ''}
                                // role="option"
                                // aria-selected={index === selectedIndex}
                            >
                                <div className={styles.Options__Option}>
                                    <div>
                                        <LocationOn 
                                            className={styles.Options__OptionIcon}
                                        />
                                        </div>
                                    <div>{option.name}</div>
                                </div>                              
                            </li>
                        ))} 
                </ul>
            </div>
        </div>
    )
}